var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-emptySupplier" }, [
    _c(
      "div",
      { staticClass: "m-emptyState m-emptyState--large" },
      [
        _vm._t("title"),
        _vm._v(" "),
        _c("p", { staticClass: "m-emptyState_subtitle" }, [
          _vm._v(
            "\n      Vamos juntos nos conectar com fornecedores da sua região!\n      "
          ),
          _c(
            "a",
            {
              staticClass: "c-emptySupplier_button",
              attrs: { href: _vm.smartQuotationLink },
            },
            [_vm._v("Faça uma Cotação Inteligente")]
          ),
        ]),
        _vm._v(" "),
        _vm._t("image"),
        _vm._v(" "),
        _vm._t("paragraph"),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticClass:
          "m-paragraphText m-paragraphText--center s-marginTop-sm s-marginBottom-none",
      },
      [
        _c(
          "a",
          { staticClass: "m-linkText", attrs: { href: _vm.supplierUrl } },
          [_vm._v("\n      É fornecedor? Cadastre aqui sua empresa\n    ")]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }